import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=4654517b&scoped=true&"
import script from "./Districts.vue?vue&type=script&lang=js&"
export * from "./Districts.vue?vue&type=script&lang=js&"
import style0 from "./Districts.vue?vue&type=style&index=0&id=4654517b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654517b",
  null
  
)

export default component.exports